import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import TopCard from "../../components/Student/Dashboard/TopCard";
import Table from "../../components/Student/Dashboard/Table";
import RightOptionsPanel from "../../components/Student/Dashboard/RightOptionsPanel";
import Calculator from "../../components/Student/Dashboard/Calculator";
import Profile from "../../components/Student/Dashboard/Profile";
import Loader from "../../components/Global/Loader";
import { UserContext } from "../../context/UserContext";

function StudentDashboard() {
  const { setIsEligible } = useContext(UserContext);

  // State to store data from both API calls
  const [profileData, setProfileData] = useState(null);
  const [applicationsData, setApplicationsData] = useState(null);
  const [calculations, setCalculations] = useState([]);

  // Loading / error states
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);

        // Define a config object with the authorization headers
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Attach the token
          },
        };

        // Make two parallel requests and wait for both to complete
        const [responseOne, responseTwo, responseThree] = await Promise.all([
          axios.get(`${process.env.REACT_APP_BASE_URL}/student/profile-completeness`, config),
          axios.get(`${process.env.REACT_APP_BASE_URL}/application`, config),
          axios.get(`${process.env.REACT_APP_BASE_URL}/student/calculation/all`, config),
        ]);

        setProfileData(responseOne.data.data);
        setIsEligible(responseOne.data.data.isEligible);
        setApplicationsData(responseTwo.data.data.applications);
        setCalculations(responseThree.data.data);
      } catch (err) {
        // console.error("Error fetching data:", err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  if (isLoading) {
    return (
      <div className="relative pl-36 pr-12 mt-16 w-full py-8 bg-[#f4f8fb] h-screen">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center relative pl-36 pr-12 mt-16 w-full py-8 bg-[#f4f8fb] text-red-500 h-screen">
        Error fetching data: {error}
      </div>
    );
  }

  return (
    <>
      <div id="main-content" className="relative pl-36 pr-12 mt-16 w-full py-8 bg-[#f4f8fb]">
        <TopCard />
        <div className="flex justify-between">
          <div className="flex flex-col w-[72%] ">
            <Table applications={applicationsData} />
            <Calculator cards={calculations} setCards={setCalculations} />
          </div>
          <div className="flex flex-col w-[26%] space-y-6">
            <RightOptionsPanel />
            <Profile profileData={profileData} />
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentDashboard;
